// extracted by mini-css-extract-plugin
export default {"copilotEmailRow":"CopilotEmail_copilotEmailRow__RcwiM"};